import React, { useState } from "react";
import { Link } from "react-router-dom";

const FAQ = () => {
  const faqs = [
    {
      question: "How do I sell my Farm Equipment?",
      staticAnswer:
        "You can sell your Farm Equipment by listing it on Krishi Sadhan website or Krishi Mart mobile applications."
    },
    {
      question: "How can I list my equipment?",
      staticAnswer:
        "Listing on Krishi Mart is quite easy. Just click on the button LIST YOUR EQUIPMENT on the top right corner of the website. Choose equipment type and location and click “List Now”. Fill in the details of the equipment and click on the submit button once you complete it."
    },
    {
      question: "How do I sell my used tractor?",
      staticAnswer:
        "You can sell your new or used tractor by listing it on Krishi Mart website or mobile applications. Don’t forget to mark it as new or used while creating equipment listing."
    },
    {
      question: "Is there an option to buy equipment?",
      staticAnswer:
        "Yes there is an option to buy equipment as well. Some providers are open to selling equipment on Krishi Mart with a fair deal."
    },
    {
      question: "I don't have a website, Can I still sell on Krishi Mart?",
      staticAnswer:
        "You don't need a website to start selling on Krishi Mart. Once you complete registration, you will have access to your account where you can manage your equipment listing."
    },
    {
      question: "How can I communicate with you?",
      staticAnswer: (
        <>
          Go to our{" "}
          <Link to="/contact">
            <span className="text-blue-500 underline">Contact Us</span>
          </Link>{" "}
          page
        </>
      )
    }
  ];

  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState({});
  const [error, setError] = useState({});

  const fetchAnswer = async (q, idx) => {
    if (answers[idx]) return;            // already fetched
    setLoading((l) => ({ ...l, [idx]: true }));
    setError((e) => ({ ...e, [idx]: null }));

    try {
      const res = await fetch(
        "https://krishimart-back.onrender.com/api/v2/chatbot/chat",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: q })
        }
      );
      if (!res.ok) throw new Error(`Status ${res.status}`);
      const { faqResponse, aiResponse } = await res.json();
      const reply = faqResponse || aiResponse || "No answer available.";
      setAnswers((a) => ({ ...a, [idx]: reply }));
    } catch (err) {
      console.error(err);
      setError((e) => ({ ...e, [idx]: "Failed to load answer." }));
    } finally {
      setLoading((l) => ({ ...l, [idx]: false }));
    }
  };

  return (
    <section className="text-gray-700">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-lg leading-relaxed mx-auto">
            The most common questions about how our business works.
          </p>
        </div>
        <div className="flex flex-wrap -mx-4">
          {faqs.map((f, idx) => (
            <div key={idx} className="w-full lg:w-1/2 px-4 py-2">
              <details
                onClick={() => fetchAnswer(f.question, idx)}
                className="mb-4 rounded-lg border border-gray-200"
              >
                <summary className="cursor-pointer font-semibold text-lg bg-gray-100 rounded-t-lg py-2 px-4">
                  {f.question}
                </summary>
                <div className="p-4 bg-white">
                  {loading[idx] ? (
                    <p className="italic text-gray-500">Loading…</p>
                  ) : error[idx] ? (
                    <p className="text-red-500">{error[idx]}</p>
                  ) : answers[idx] ? (
                    <p className="text-gray-800">{answers[idx]}</p>
                  ) : (
                    <p className="text-gray-800">{f.staticAnswer}</p>
                  )}
                </div>
              </details>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
